import React from 'react'
import GreyBig from './../GreyBig'

import { numberAddCommas } from 'servos/formValidations'

class CurrentHome extends React.Component {
  render() {
    const {
      residentialStatusLabel,
      residentialStatus,
      sellCurrentHomeLabel,
      currentHomeWorth,
      currentHomeRentWorth,
      sellCurrentHome,
      currentHomeRentFrequency,
    } = this.props.expenses
    return (
      <div>
        <GreyBig size='4' grey='Residential status' big={ residentialStatusLabel }/>
        {
          ( residentialStatus == 'own' ) && (
            <div>
              <GreyBig
                size='4'
                grey='Sell current home'
                big={ sellCurrentHomeLabel }
              />
              <GreyBig
                size='4'
                grey={ 'Value of current home' }
                big={ '$' + numberAddCommas(currentHomeWorth) }
              />
              {
                !sellCurrentHome && (
                  <GreyBig
                    size='4'
                    grey={ 'Rent value of current home' }
                    big={ '$' + numberAddCommas(currentHomeRentWorth) + ' ' + currentHomeRentFrequency }
                  />
                )
              }
            </div>
          )
        }
      </div>
    )
  }
}

export default CurrentHome
